import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { PayMethodModel, CurrencyModel } from '../../../models/consultation/cash-sale.model';
import { FormControl } from '@angular/forms/src/model';
import { isString, isNumber } from 'util';
import { Router } from '@angular/router';
import { ConsultationStepInfo } from '../../../models/consultation/consultation.model';
import { CashSaleService } from './cash-sale.service';
import { InvoiceService } from './invoice.service';

@Component({
  selector: 'email-invoice-popup',
  templateUrl: 'email-invoice-popup.component.html',
  providers: [CashSaleService]
})

export class EmailInvoicePopupComponent implements OnInit {
  public isAssignSuccess = false;
  createGroupForm: FormGroup;
  public createGroupModel = {
    to: ''
  }
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef < EmailInvoicePopupComponent > ,
    public router: Router,
    public cashSaleService: CashSaleService,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.createGroupModel.to = this.data.email;
    this.createGroupForm.controls['to'].valueChanges.subscribe(data => {
      if (data) {
        let arr = data.split(';');
        if (arr) {
          if (arr.length) {
            const lens = arr.length;
            if (lens > 1) {
              if (arr[lens - 1] === '') {
                arr = arr.slice(0, lens - 1);
              }
            }
            const isValidEmail = arr.every(x => this.checkIsValidEmail(x));
            if (isValidEmail) {
              this.createGroupForm.controls['to'].setErrors(null);
            } else {
              this.createGroupForm.controls['to'].setErrors({
                'invalidEmail': true
              });
            }
          }
        }
      }
    });
  }

  checkIsValidEmail(str: string): boolean {
    if (str)
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str);
    return false;
  }

  createForm() {
    this.createGroupForm = this.formBuilder.group({
      to: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if (this.createGroupForm.valid) {
      // call API send email and close if send successfully
      this.cashSaleService.sendInvoice(this.data.invoiceNo, this.createGroupForm.value.to, this.data.currency).subscribe();

      this.isAssignSuccess = true;
      this.onCloseDialog();
      // this.router.navigateByUrl('consultation/waiting-room');
    }
  }

  public onCloseDialog() {
    this.dialogRef.close(this.isAssignSuccess);
  }

}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/email-invoice-popup.component.ts